import Swiper from 'swiper';
import { swiperObserver } from './swiper.utils';

export const swiperOnResize = (breakpoint, swiperClass, swiperSettings, startOnView) => {
    let swiper = null;

    breakpoint = window.matchMedia(breakpoint);

    const enableSwiper = function (className, settings) {
        swiper = new Swiper(className, settings);

        if (startOnView) {
            swiperObserver(swiper);
        }
    };

    const checker = function () {
        if (breakpoint.matches) {
            if (!swiper) {
                enableSwiper(swiperClass, swiperSettings);
            }
        } else {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }
    };

    breakpoint.addEventListener("change", checker);
    checker();

    return {swiper};
};